import React, { useState, useEffect, useContext } from 'react';

import { Link } from 'react-router-dom';

import { ContextSindico } from '../../../services/sindico';

import { Container, PageContainer, PageTitle } from '../styles';
import {
  BackToPodeMorarText,
  ButtonContainer,
  ErrorLoginMessage,
} from './styles';

import { ButtonPrimary, Spinner } from '../../../Components/StyledComponent';

import Input from '../../../Components/Input';

import handleInputChange from '../../../Utils/handleInputChange';

import { maskCpfCnpj } from '../../../Utils/masks';

import { useHistory } from 'react-router-dom';

import loadSindico from '../loadSindico';

import { validarCPFCNPJ, validarEmail } from '../../../Utils/validations';

export default function Sindico() {
  const INITIAL_USER_DATA_STATE = {
    value: '',
    isValid: false,
    touched: false,
  };

  const [cpfCnpj, setCpfCnpj] = useState(INITIAL_USER_DATA_STATE);
  const [email, setEmail] = useState(INITIAL_USER_DATA_STATE);
  const [loading, setLoading] = useState(true);
  const [isDoingLogin, setIsDoingLogin] = useState(false);

  const { handleSindicoAuthentication, errorSindicoAuth } =
    useContext(ContextSindico);

  const history = useHistory();

  useEffect(() => {
    if (loadSindico()) {
      history.push('/sindico/inicio');
    } else {
      sessionStorage.removeItem('sindico');
    }

    setLoading(false);
  }, []);

  if (loading) {
    return <p>loading...</p>;
  }

  const isInvalidUserData = () => {
    const userData = [cpfCnpj, email];

    const isInvalid = userData.find((data) => !data.isValid);
    return isInvalid;
  };

  const validateCpfCnpj = (cpfCnpj) => {
    const isValid = validarCPFCNPJ(cpfCnpj);

    return isValid;
  };

  const validateEmail = (email) => {
    const isValid = validarEmail(email);

    return isValid;
  };

  const touchField = (data, setData) => {
    setData({ ...data, touched: true });
  };

  const handleLogin = async () => {
    setIsDoingLogin(true);
    await handleSindicoAuthentication({
      cpfCnpj: cpfCnpj.value,
      email: email.value,
    });

    setIsDoingLogin(false);
  };
  return (
    <PageContainer>
      <Container
        width={'550px'}
        maxWidth={'550px'}
        margin={'auto'}
        height={'fit-content!important'}
        minHeight={'fit-content'}
      >
        <PageTitle>Identificação</PageTitle>
        <p>Olá síndico(a) informe os dados abaixo para acessar:</p>
        <Input
          handleInputChange={(e) =>
            handleInputChange(e, setCpfCnpj, cpfCnpj, validateCpfCnpj)
          }
          name={'cpfCnpj'}
          type={'cpfCnpj'}
          labelName={'CPF ou CNPJ da sua empresa'}
          value={maskCpfCnpj(cpfCnpj.value)}
          size={'100%'}
          error={!cpfCnpj.isValid && cpfCnpj.touched}
          errorMessage={'CPF ou CNPJ inválido.'}
          onBlur={() => touchField(cpfCnpj, setCpfCnpj)}
        />
        <Input
          handleInputChange={(e) =>
            handleInputChange(e, setEmail, email, validateEmail)
          }
          name={'email'}
          type={'email'}
          labelName={'E-mail'}
          value={email.value}
          size={'100%'}
          error={!email.isValid && email.touched}
          errorMessage={'Email inválido.'}
          onBlur={() => touchField(email, setEmail)}
        />
        <ButtonContainer>
          <ButtonPrimary
            tema={{ primaryColor: '#1D3054' }}
            fullWidth
            onClick={handleLogin}
            disabled={isInvalidUserData() || isDoingLogin}
            type={'button'}
          >
            ACESSAR
            {isDoingLogin && <Spinner />}
          </ButtonPrimary>
        </ButtonContainer>
        {errorSindicoAuth && (
          <ErrorLoginMessage>
            {errorSindicoAuth.response === 'Erro ao validar o síndico.'
              ? `CPF/CNPJ ou E-mail inválidos`
              : 'Serviço temporiamente indisponível, tente novamente mais tarde.'}
          </ErrorLoginMessage>
        )}
        <BackToPodeMorarText>
          Voltar ao acesso do Pode Morar: <Link to={'/'}> Clique aqui</Link>
        </BackToPodeMorarText>
      </Container>
    </PageContainer>
  );
}
